import axios from "axios";

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

let user = JSON.parse(localStorage.getItem("user"));

if (user) {
  axios.defaults.headers.common = {
    Authorization: "Bearer " + user.token,
  };
}

axios.interceptors.response.use(
  (res) => {
    if (res.data && res.data.errorCode === 401) {
      localStorage.removeItem("user");
      window.location.href = "/#/superadmin/login";
    }
    return res;
  },
  (error) => {
    if (error.response && error.response.data && error.response.data.errorCode === 401) {
      localStorage.removeItem("user");
      window.location.href = "/#/superadmin/login";
    }
    return error;
  }
);

export default axios;